import React from "react";
import { Paper, PaperProps, Typography } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { useHistory, useLocation, useParams } from "react-router";
import { SimpleRelease } from "../../../../../../../common/types/release/simple-release";
import { getArtistReleases } from "../../../../sdk/release";

export const ArtistSummaryReleases: React.FC<PaperProps> = (props) => {
  const history = useHistory();
  const location = useLocation();
  const { artistId } = useParams<{ artistId: string }>();

  const [releases, setReleases] = React.useState<SimpleRelease[]>([]);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    setLoading(true);
    getArtistReleases(artistId)
      .then((list) => setReleases(list))
      .finally(() => setLoading(false));
  }, [artistId]);

  return (
    <Paper
      {...props}
      style={{ padding: "20px", overflow: "hidden", ...props.style }}
    >
      <Typography variant="h6">Releases</Typography>

      <div style={{ display: "flex", height: "450px", marginTop: "20px" }}>
        <DataGrid
          loading={loading}
          rows={releases}
          columns={[
            { field: "title", headerName: "Title", width: 400 },
            { field: "status", headerName: "Status", width: 200 },
          ]}
          pageSize={20}
          onRowClick={(params) => history.push(`/releases/${params.row.id}`, location.state)}
        />
      </div>
    </Paper>
  );
};
